import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Mail, MapPin, FileText } from "lucide-react";

export default function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-gray-900 text-white pt-16 pb-8">
            <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-12">

                <div className="col-span-1 md:col-span-1">
                    <img src="/images/smartreceptors_logo.png" alt="SmartReceptors" className="h-7 mb-4 object-contain" />
                    <p className="text-sm text-gray-400 leading-relaxed mb-4">
                        AI-Driven Technology Solutions for Pharma and Biotech. Transforming drug discovery with generative AI.
                    </p>
                    <p className="text-sm text-gray-400">
                        GSTIN: <span className="font-mono">09AWOPK4452G1Z8</span>
                    </p>
                </div>

                <div>
                    <h4 className="font-semibold text-white mb-4">Company</h4>
                    <ul className="space-y-2 text-sm text-gray-400">
                        <li><Link to="/" className="hover:text-white transition-colors">About Us</Link></li>
                        <li><Link to="/services" className="hover:text-white transition-colors">Expertise</Link></li>
                        <li><Link to="/products" className="hover:text-white transition-colors">Products</Link></li>
                        <li><Link to="/careers" className="hover:text-white transition-colors">Careers</Link></li>
                        <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
                    </ul>
                </div>

                <div className="col-span-1 md:col-span-2">
                    <h4 className="font-semibold text-white mb-4">Contact Us</h4>
                    <div className="space-y-3 text-sm text-gray-400">
                        <div className="flex items-start gap-3">
                            <MapPin size={18} className="text-primary-400 mt-0.5 shrink-0" />
                            <div>
                                <p>TF-02, Third Floor, Sun Twilight Metro Street,</p>
                                <p>Delta-1 Metro Station, Sector -27</p>
                                <p>Greater Noida-201308</p>
                            </div>
                        </div>
                        <div className="flex items-center gap-3">
                            <Mail size={18} className="text-primary-400" />
                            <a href="mailto:info@smartreceptors.com" className="hover:text-white transition-colors">info@smartreceptors.com</a>
                        </div>

                    </div>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-6 mt-12 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4">
                <p className="text-sm text-gray-400">© {currentYear} SmartReceptors. All rights reserved.</p>
                <div className="flex gap-4">
                    <a href="https://www.linkedin.com/company/smartreceptors/" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-white transition-colors">
                        <Linkedin size={20} />
                    </a>
                </div>
            </div>
        </footer>
    );
}
